export function Mitchell1SettingsCtrl (
  $state,
  $scope,
  $translate,
  confirm,
  integrations,
  messages,
  workshopAPI
) {
  $scope.integrations = integrations;
  $scope.loaded       = true;

  $scope.save = function (form) {
    workshopAPI.patch('/company_integrations', $scope.integrations, 'company_integration').then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      $state.reload();
    }).catch(err => {
        messages.error(err);
    });
  };

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'Mitchell1' })).then(() => {
      return workshopAPI.get('/company_integration/add_mitchell1');
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: 'Mitchell1' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.remove = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.REMOVE', { name: 'Mitchell1' })).then(() => {
      return workshopAPI.get('/company_integration/remove_mitchell1')
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.REMOVED', { name: 'Mitchell1' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };
}
